(ns app.front.view.country-picker
  (:require [app.front.ui.locale-select :as ui-locale-select]
            [clojure.string :as str]
            [core.front.config :as front-config]
            [core.front.event :refer [<sub >evt]]
            [re-frame.core-instrumented :as rf]))

(def country-options
  {"ca" "Canada"
   "us" "USA"})

(defn country-url [country-code]
  (str/replace js/window.location.href #"(\w{2})\.cloudpermit\.com" (str country-code ".cloudpermit.com")))

(defn country-option-image [country-code]
  (str "/asset/img/flags/" country-code ".png"))

(rf/reg-event-fx ::navigate-to-country
  (fn [_ [_ country-code]]
    {:navigate-to (country-url country-code)}))

;;
;; Compact pickers for new login page
;;

(defn compact-country-picker
  "Compact country picker with text-only toggle (no flag), smaller size."
  []
  (let [tr (<sub [:tr])]
    [ui-locale-select/locale-select
     {:value     (<sub [::front-config/country])
      :label     (tr [:login-new/country])
      :on-change #(>evt [::navigate-to-country %])
      :options   (map (fn [[code country-name]]
                        {:value         code
                         :label         country-name
                         :trigger-label country-name
                         :icon-src      (country-option-image code)})
                      country-options)}]))
